import React, { useEffect, useState, useRef } from "react";
import MainMenu from "./MainMenu";
import { Rooms } from "../rooms/Rooms";
import MainClock from "./MainClock";
import { useLocation, Outlet } from "react-router-dom";
import {
  Avatar,
  Badge,
  Button,
  Checkbox,
  Drawer,
  Empty,
  Table,
  Tabs,
  Tag,
  Tooltip,
  Modal
} from "antd";
import { useAuth } from "../login/AuthContext";
import { useCode } from "../login/CodeContext";
import { Z_NotFoundSample } from "./Z_NotFoundSample";
import { SalesTable1 } from "./SalesTable1";
import { SalesTable2 } from "./SalesTable2";
import { NotificationCard } from "./NotificationCard";
import { BellOutlined, BellFilled, LogoutOutlined, MenuOutlined, BarChartOutlined, HomeOutlined } from "@ant-design/icons";
import { accomIdApi, notifySearchApi, registerPushNotificationApi, unregisterPushNotificationApi, checkPushNotificationApi } from "../api/api";

export const Container = () => {
  // ========================================================
  // 세션 타임아웃 기능 추가
  const timeoutRef = useRef(null);
  const warningTimeoutRef = useRef(null);
  const SESSION_TIMEOUT =  30 * 60 * 1000; // 30분 (밀리초 단위)
  const WARNING_TIMEOUT =  25 * 60 * 1000; // 25분 (밀리초 단위)

  const showModal = (title, content, onOk) => {
    Modal.warning({
      title: title,
      content: content,
      onOk: onOk,
    });
  };

  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    if (warningTimeoutRef.current) {
      clearTimeout(warningTimeoutRef.current);
    }

    warningTimeoutRef.current = setTimeout(() => {
      showModal(
        "경고",
        "30분 동안 활동이 없을시 자동 로그아웃 됩니다.",
        () => {}
      );
    }, WARNING_TIMEOUT);

    timeoutRef.current = setTimeout(() => {
      showModal(
        "로그아웃",
        "30분 이상 활동이 없어 자동 로그아웃 됩니다. 다시 로그인해주세요.",
        handleLogout
      );
    }, SESSION_TIMEOUT);
  };

  useEffect(() => {
    // 사용자 활동 감지 이벤트 등록
    const events = ["mousemove", "keydown", "click", "scroll"];
    events.forEach((event) => window.addEventListener(event, resetTimeout));

    resetTimeout(); // 초기 타이머 설정

    return () => {
      // 컴포넌트 언마운트 시 타이머와 이벤트 리스너 정리
      clearTimeout(timeoutRef.current);
      events.forEach((event) =>
        window.removeEventListener(event, resetTimeout)
      );
    };
  }, []);
  // ========================================================

  // ========================================================
  // Accom-id : 업소 정보
  const [accomOnlyList, setAccomOnlyList] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await accomIdApi();
        const resArray = Object.entries(res.accoms);
        const accomIdAllArray = resArray.map(([key, value]) => {
          return {
            key: key,
            value: value,
            name: value.name,
          };
        });
        setAccomOnlyList(accomIdAllArray);
        // console.log(accomOnlyList[0].name);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);
  // ========================================================


  // ========================================================

  // MainMenu 펼짐 제어
  const [collapsed, setCollapsed] = useState(false);
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };
  const handleMenuResize = () => {
    if (window.innerWidth <= 870) {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }
  };
  useEffect(() => {
    handleMenuResize();
    window.addEventListener("resize", handleMenuResize);
    return () => {
      window.removeEventListener("resize", handleMenuResize);
    };
  }, []);

  // 경로
  const { pathname } = useLocation();

  // 로그아웃
  const { logout } = useAuth();
  const { removeCode } = useCode();
  const handleLogout = () => {
    logout();
    //removeCode();
  };
  // console.log(pathname);

  // 메뉴 Key
  const [currentMenuKey, setCurrentMenuKey] = useState("1");

  // 매출 drawer
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  // 매출 tab
  const onChangeSalesTableTab = (key) => {
    console.log(key);
  };

  // 알람창 drawer
  const [openAlarm, setOpenAlarm] = useState(false);
  const showDrawerAlarm = () => {
    setOpenAlarm(true);
  };
  const onCloseAlarm = () => {
    setOpenAlarm(false);
  };

  // 푸시 알림 상태 관리
  const [isPushEnabled, setIsPushEnabled] = useState(false);
  const [oneSignalUserId, setOneSignalUserId] = useState(null);

  // 컴포넌트 마운트 시 OneSignal 상태 확인 및 서버 상태 동기화
  useEffect(() => {
    const checkOneSignalStatus = async () => {
      try {
        console.log('OneSignal 상태 확인 시작');
        
        // OneSignal이 이미 index.html에서 초기화되었으므로 초기화 상태만 확인
        if (!window.OneSignal) {
          console.log('OneSignal SDK가 아직 로드되지 않음');
          return;
        }
        
        // 브라우저 네이티브 권한 확인
        const nativePermission = Notification.permission;
        console.log('브라우저 네이티브 권한 상태:', nativePermission);
        
        const isSubscribed = await window.OneSignal.User.PushSubscription.optedIn;
        console.log('OneSignal 구독 상태:', isSubscribed);
        
        // 초기화 시점에서 미리 구독된 상태 확인
        if (window.OneSignal.preSubscribed || window.OneSignal.subscriptionSuccess) {
          console.log('초기화 시점에서 이미 구독 완료됨');
          const userId = await window.OneSignal.User.PushSubscription.id;
          if (userId) {
            console.log('미리 구독된 User ID:', userId);
            setOneSignalUserId(userId);
            setIsPushEnabled(true);
            await checkServerPushStatus(userId);
            return;
          }
        }
        
        // 브라우저 권한 상태 확인 및 로깅 (자동 구독은 사용자 제스처 없이 불가능)
        if (nativePermission === 'granted' && !isSubscribed) {
          console.log('브라우저 권한 허용됨, 사용자가 버튼을 클릭하면 구독 가능한 상태');
          
          // OneSignal 상태 정보만 로깅
          try {
            const pushSupported = await window.OneSignal.Notifications.isPushSupported();
            const oneSignalPermission = await window.OneSignal.Notifications.permission;
          console.log('OneSignal 상태 정보 (환경별):', {
            pushSupported,
            oneSignalPermission,
            nativePermission,
            message: '사용자 제스처 필요 - 자동 구독 불가',
            environment: {
              platform: navigator.platform,
              isMacOS: navigator.userAgent.includes('Mac'),
              isWindows: navigator.userAgent.includes('Windows'),
              isWSL: navigator.userAgent.includes('Linux'),
              isChrome: navigator.userAgent.includes('Chrome'),
              isSafari: navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome'),
              protocol: window.location.protocol,
              hostname: window.location.hostname
            }
          });
            
            // 토글을 false로 설정하되, 구독 가능한 상태임을 표시
            setIsPushEnabled(false);
          } catch (error) {
            console.log('OneSignal 상태 확인 중 오류:', error);
            setIsPushEnabled(false);
          }
        }
        
        if (isSubscribed) {
          const userId = await window.OneSignal.User.PushSubscription.id;
          console.log('OneSignal 사용자 ID:', userId);
          setOneSignalUserId(userId);
          
          // 서버에서 알림 상태 확인
          await checkServerPushStatus(userId);
        } else {
          console.log('OneSignal 구독되지 않음, 토글 false로 설정');
          setIsPushEnabled(false);
        }
      } catch (error) {
        console.log('OneSignal 상태 확인 중 오류:', error);
        setIsPushEnabled(false);
      }
    };

    // 서버에서 푸시 알림 상태 확인
    const checkServerPushStatus = async (oneSignalId) => {
      try {
        const accomId = sessionStorage.getItem("accomId");
        if (accomId && oneSignalId) {
          console.log('서버 푸시 알림 상태 확인 중:', oneSignalId, accomId);
          const response = await checkPushNotificationApi(oneSignalId, accomId);
          console.log('서버 푸시 알림 상태 응답:', response);
          
          // 서버 응답에 따라 토글 상태 설정
          // API 응답 구조에 따라 조정 필요 (예: response.isEnabled)
          if (response && response.isEnabled !== undefined) {
            console.log('서버 응답에 따른 토글 상태:', response.isEnabled);
            setIsPushEnabled(response.isEnabled);
          } else {
            // 기본적으로 OneSignal 구독 상태를 사용
            console.log('서버 응답 없음, OneSignal 구독 상태 사용: true');
            setIsPushEnabled(true);
          }
        } else {
          console.log('accomId 또는 oneSignalId 없음:', accomId, oneSignalId);
          setIsPushEnabled(false);
        }
      } catch (error) {
        console.log('서버 푸시 알림 상태 확인 중 오류:', error);
        // 오류 시 OneSignal 구독 상태를 기본값으로 사용
        setIsPushEnabled(true);
      }
    };

    // OneSignal 로딩 대기 후 상태 확인 (index.html에서 초기화됨)
    const waitForOneSignal = async () => {
      if (typeof window.OneSignal !== 'undefined' && window.OneSignal.initialized === true) {
        console.log('OneSignal SDK 초기화 완료됨, 상태 확인 시작');
        
        // OneSignal API가 실제로 사용 가능한지 확인
        try {
          // 기본 API 호출로 SDK 준비 상태 확인
          const isPushSupported = await window.OneSignal.Notifications.isPushSupported();
          console.log('OneSignal API 준비 완료, 푸시 지원:', isPushSupported);
          
          // 모든 API가 준비되었으므로 상태 확인 시작
          checkOneSignalStatus();
        } catch (apiError) {
          console.log('OneSignal API 아직 준비되지 않음, 재시도:', apiError);
          setTimeout(waitForOneSignal, 1000);
        }
      } else {
        console.log('OneSignal SDK 초기화 대기 중...');
        setTimeout(waitForOneSignal, 1000);
      }
    };

    // 초기 지연을 추가하여 OneSignal이 완전히 초기화될 때까지 대기
    setTimeout(() => {
      waitForOneSignal();
    }, 3000);
  }, []);

  // OneSignal 푸시 알림 권한 요청 함수
  const requestNotificationPermission = async () => {
    console.log('OneSignal 알림 받기 버튼이 클릭되었습니다!');
    
    try {
      // OneSignal이 로드되었는지 확인
      if (typeof window.OneSignal === 'undefined') {
        console.log('OneSignal SDK가 아직 로드되지 않았습니다. 대기 중...');
        Modal.info({
          title: 'SDK 로딩 중',
          content: 'OneSignal SDK를 로딩 중입니다. 잠시 후 다시 시도해주세요.',
        });
        
        // 최대 10초 동안 OneSignal 로딩 대기
        let attempts = 0;
        const maxAttempts = 20; // 0.5초 * 20 = 10초
        
        const waitForOneSignal = () => {
          setTimeout(() => {
            attempts++;
            if (typeof window.OneSignal !== 'undefined') {
              console.log('OneSignal SDK가 로드되었습니다. 다시 시도합니다.');
              requestNotificationPermission();
            } else if (attempts < maxAttempts) {
              waitForOneSignal();
            } else {
              Modal.error({
                title: 'SDK 로딩 실패',
                content: 'OneSignal SDK를 로드할 수 없습니다. 페이지를 새로고침하고 다시 시도해주세요.',
              });
            }
          }, 500);
        };
        
        waitForOneSignal();
        return;
      }

      console.log('OneSignal SDK 확인됨:', window.OneSignal);

      // OneSignal이 이미 index.html에서 초기화되었으므로 중복 초기화 방지
      console.log('OneSignal SDK 초기화 상태 확인됨');

      console.log('OneSignal이 초기화되었습니다.');

      // 현재 구독 상태 확인
      const isPushSupported = await window.OneSignal.Notifications.isPushSupported();
      console.log('푸시 알림 지원 여부:', isPushSupported);

      if (!isPushSupported) {
        Modal.error({
          title: '지원되지 않는 환경',
          content: '이 브라우저 또는 환경에서는 푸시 알림을 지원하지 않습니다.',
        });
        return;
      }

      // 브라우저 네이티브 권한 상태 확인
      const nativePermission = await Notification.permission;
      console.log('브라우저 네이티브 권한 상태:', nativePermission);
      
      // OneSignal 권한 상태 확인
      const permission = await window.OneSignal.Notifications.permission;
      console.log('현재 OneSignal 권한 상태:', permission);

      // 이미 구독되어 있는지 확인
      const isSubscribed = await window.OneSignal.User.PushSubscription.optedIn;
      console.log('현재 구독 상태:', isSubscribed);

      // 브라우저 권한은 허용되어 있지만 OneSignal 구독이 안된 경우 처리
      if (nativePermission === 'granted' && !isSubscribed) {
        console.log('브라우저 권한은 허용되어 있음, OneSignal 구독 진행');
        try {
          await window.OneSignal.User.PushSubscription.optIn();
          const finalSubscribed = await window.OneSignal.User.PushSubscription.optedIn;
          
          if (finalSubscribed) {
            const userId = await window.OneSignal.User.PushSubscription.id;
            console.log('기존 권한으로 구독 완료! 사용자 ID:', userId);
            
            Modal.success({
              title: '알림 설정 완료',
              content: '기존 브라우저 권한으로 OneSignal 푸시 알림이 설정되었습니다!',
            });

            // 상태 업데이트
            setIsPushEnabled(true);
            setOneSignalUserId(userId);

            // 서버에 등록 API 호출
            try {
              const accomId = sessionStorage.getItem("accomId");
              if (accomId) {
                await registerPushNotificationApi(userId, accomId);
                console.log('서버에 푸시 알림 등록 완료');
              }
            } catch (apiError) {
              console.error('서버 등록 API 호출 실패:', apiError);
            }
            return;
          }
        } catch (error) {
          console.log('기존 권한으로 구독 실패:', error);
        }
      }

      if (isSubscribed) {
        // 이미 구독되어 있는 경우
        Modal.success({
          title: '알림 이미 설정됨',
          content: 'OneSignal 푸시 알림이 이미 설정되어 있습니다!',
        });
        
        // 사용자 ID 확인
        const userId = await window.OneSignal.User.PushSubscription.id;
        console.log('OneSignal 사용자 ID:', userId);
        return;
      }

      // OneSignal 권한 요청 및 구독
      console.log('OneSignal 권한 요청 중...');
      
      let granted = false;
      
      // OneSignal v16 권한 요청 방법 (사용자 제스처에서 실행됨)
      try {
        console.log('OneSignal 권한 요청 시작');
        
        // 브라우저 권한이 이미 허용된 경우
        if (nativePermission === 'granted') {
          console.log('브라우저 권한이 이미 허용됨, OneSignal 구독 직접 시도');
          
          // 브라우저 권한이 있으므로 바로 구독 시도
          try {
            console.log('OneSignal 구독 시도 중...');
            
            // 구독 전 상태 확인
            const preOptInStatus = await window.OneSignal.User.PushSubscription.optedIn;
            const prePermission = await window.OneSignal.Notifications.permission;
            const preUserId = await window.OneSignal.User.onesignalId;
            console.log('구독 시도 전 상태:', {
              optedIn: preOptInStatus,
              permission: prePermission,
              userId: preUserId,
              nativePermission: Notification.permission
            });
            
            // 브라우저 권한이 허용된 상태에서 OneSignal 권한이 false인 경우
            // OneSignal에 명시적으로 권한 상태를 알려주는 시도
            if (Notification.permission === 'granted' && !prePermission) {
              console.log('브라우저 권한과 OneSignal 권한 불일치, 동기화 시도');
              try {
                // OneSignal에 권한 요청 (이미 허용된 상태이므로 프롬프트 없이 동기화됨)
                await window.OneSignal.Notifications.requestPermission();
                console.log('OneSignal 권한 동기화 완료');
                
                // 동기화 후 잠시 대기
                await new Promise(resolve => setTimeout(resolve, 1000));
              } catch (syncError) {
                console.log('OneSignal 권한 동기화 실패:', syncError);
              }
            }
            
            // Service Worker 상태 확인 및 등록
            if ('serviceWorker' in navigator) {
              const registrations = await navigator.serviceWorker.getRegistrations();
              console.log('Service Worker 등록 상태:', registrations.length > 0);
              console.log('Service Worker 등록 정보:', registrations.map(reg => ({
                scope: reg.scope,
                active: !!reg.active,
                scriptURL: reg.active?.scriptURL
              })));
              
              // Service Worker가 등록되지 않은 경우 수동 등록 시도
              if (registrations.length === 0) {
                console.log('Service Worker가 등록되지 않음, 수동 등록 시도');
                try {
                  const registration = await navigator.serviceWorker.register('/OneSignalSDKWorker.js', {
                    scope: '/'
                  });
                  console.log('Service Worker 수동 등록 성공:', registration);
                  
                  // Service Worker 활성화 대기
                  await new Promise((resolve) => {
                    if (registration.active) {
                      console.log('Service Worker 이미 활성화됨');
                      resolve();
                    } else {
                      console.log('Service Worker 활성화 대기 중...');
                      registration.addEventListener('statechange', () => {
                        if (registration.active) {
                          console.log('Service Worker 활성화 완료');
                          resolve();
                        }
                      });
                      
                      // 최대 5초 대기
                      setTimeout(resolve, 5000);
                    }
                  });
                } catch (swError) {
                  console.error('Service Worker 수동 등록 실패:', swError);
                }
              } else {
                // 이미 등록된 Service Worker가 활성화되었는지 확인
                const activeWorker = registrations.find(reg => reg.active);
                if (!activeWorker) {
                  console.log('등록된 Service Worker가 비활성화 상태, 활성화 대기');
                  await new Promise(resolve => setTimeout(resolve, 3000));
                }
              }
            }
            
            // Service Worker 활성화 후 OneSignal 상태 재확인
            console.log('Service Worker 활성화 후 OneSignal 상태 재확인');
            const afterSwPermission = await window.OneSignal.Notifications.permission;
            const afterSwSupported = await window.OneSignal.Notifications.isPushSupported();
            console.log('Service Worker 활성화 후 상태:', {
              permission: afterSwPermission,
              pushSupported: afterSwSupported,
              nativePermission: Notification.permission
            });
            
            // optIn 호출 - 강화된 구독 로직
            console.log('OneSignal 구독 시도 시작...');
            
            try {
              // 1. 먼저 권한 동기화 시도
              console.log('권한 상태 강제 동기화 시도...');
              await window.OneSignal.Notifications.requestPermission();
              
              // 2. slidedown 프롬프트 시도
              let slidedownSuccess = false;
              if (window.OneSignal.Slidedown && window.OneSignal.Slidedown.promptPush) {
                console.log('Slidedown.promptPush() 시도...');
                try {
                  await window.OneSignal.Slidedown.promptPush();
                  console.log('Slidedown.promptPush() 완료');
                  slidedownSuccess = true;
                } catch (slideError) {
                  console.log('Slidedown.promptPush() 실패:', slideError);
                }
              } else if (window.OneSignal.showSlidedownPrompt) {
                console.log('showSlidedownPrompt() 시도...');
                try {
                  await window.OneSignal.showSlidedownPrompt();
                  console.log('showSlidedownPrompt() 완료');
                  slidedownSuccess = true;
                } catch (slideError) {
                  console.log('showSlidedownPrompt() 실패:', slideError);
                }
              } else {
                // 직접 optIn 시도
                console.log('Slidedown 메서드 없음, 직접 optIn 시도');
                const optInResult = await window.OneSignal.User.PushSubscription.optIn();
                console.log('OneSignal.User.PushSubscription.optIn() 결과:', optInResult);
              }
            } catch (slidedownError) {
              console.log('Slidedown 실패, 직접 optIn 시도:', slidedownError.message);
              
              // optIn 직접 시도
              const optInResult = await window.OneSignal.User.PushSubscription.optIn();
              console.log('OneSignal.User.PushSubscription.optIn() 결과:', optInResult);
            }
            
            // 3. 추가 강제 구독 시도 (slidedown 후에도 구독이 안된 경우)
            console.log('구독 처리 대기 중...');
            await new Promise(resolve => setTimeout(resolve, 2000));
            
            // 중간 상태 확인
            let tempSubscriptionStatus = await window.OneSignal.User.PushSubscription.optedIn;
            console.log('중간 구독 상태 확인:', tempSubscriptionStatus);
            
            if (!tempSubscriptionStatus) {
              console.log('구독이 아직 완료되지 않음, 강제 optIn 재시도');
              try {
                // 강제로 다시 한번 optIn 시도
                const forceOptInResult = await window.OneSignal.User.PushSubscription.optIn();
                console.log('강제 optIn 결과:', forceOptInResult);
                
                // 추가 대기
                await new Promise(resolve => setTimeout(resolve, 2000));
              } catch (forceOptInError) {
                console.log('강제 optIn 실패:', forceOptInError);
              }
            }
            
            // 최종 권한 상태 재확인
            const updatedPermission = await window.OneSignal.Notifications.permission;
            const subscriptionStatus = await window.OneSignal.User.PushSubscription.optedIn;
            const postUserId = await window.OneSignal.User.onesignalId;
            const pushSubscriptionId = await window.OneSignal.User.PushSubscription.id;
            
            console.log('구독 후 상세 상태:', {
              permission: updatedPermission,
              optedIn: subscriptionStatus,
              userId: postUserId,
              pushSubscriptionId: pushSubscriptionId,
              nativePermission: Notification.permission
            });
            
            // 4. 전역 상태 확인 (리스너에서 설정된 값)
            if (!subscriptionStatus && window.OneSignal.subscriptionSuccess) {
              console.log('리스너에서 구독 성공이 감지되었으나 상태가 아직 반영되지 않음');
              granted = true;
            } else {
              granted = subscriptionStatus; // 구독 상태로 판단
            }
            
          } catch (subscriptionError) {
            console.error('OneSignal 구독 실패 상세:', {
              error: subscriptionError,
              message: subscriptionError.message,
              stack: subscriptionError.stack,
              name: subscriptionError.name
            });
            
            // 구독 실패 시 권한 요청 시도
            try {
              console.log('구독 실패로 인한 권한 요청 시도');
              const directPermission = await window.OneSignal.Notifications.requestPermission();
              console.log('OneSignal 직접 권한 요청 결과:', directPermission);
              granted = directPermission;
            } catch (permissionError) {
              console.error('OneSignal 권한 요청도 실패:', {
                error: permissionError,
                message: permissionError.message
              });
              granted = false;
            }
          }
          
        } else {
          // 브라우저 권한이 없는 경우 권한 요청부터
          console.log('브라우저 권한 없음, 권한 요청 진행');
          
          // OneSignal의 권한 요청 (브라우저 권한도 함께 요청됨)
          const directPermission = await window.OneSignal.Notifications.requestPermission();
          console.log('OneSignal 권한 요청 결과:', directPermission);
          granted = directPermission;
        }
        
      } catch (permissionError) {
        console.log('OneSignal 권한 요청 실패:', permissionError);
        granted = false;
      }

      if (granted) {
        console.log('권한/구독 성공, 최종 확인 진행');
        
        try {
          // 최종 구독 상태 확인
          let finalSubscribed = await window.OneSignal.User.PushSubscription.optedIn;
          console.log('최종 구독 상태 확인:', finalSubscribed);
          
          // 구독이 안된 경우 상세 분석 및 추가 시도
          if (!finalSubscribed) {
            console.log('구독 상태 false, 상세 분석 시작');
            
            // 상세 진단 정보 수집 (OS 및 브라우저 환경 포함)
            const diagnosticInfo = {
              oneSignalPermission: await window.OneSignal.Notifications.permission,
              pushSupported: await window.OneSignal.Notifications.isPushSupported(),
              nativePermission: Notification.permission,
              userAgent: navigator.userAgent,
              protocol: window.location.protocol,
              hostname: window.location.hostname,
              platform: navigator.platform,
              // OS 환경 감지
              isMacOS: navigator.userAgent.includes('Mac'),
              isWindows: navigator.userAgent.includes('Windows'),
              isWSL: navigator.userAgent.includes('Linux'),
              // 브라우저 환경 감지
              isChrome: navigator.userAgent.includes('Chrome'),
              isSafari: navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome'),
              isFirefox: navigator.userAgent.includes('Firefox'),
              isEdge: navigator.userAgent.includes('Edge')
            };
            
            // OneSignal User 정보 확인
            try {
              diagnosticInfo.onesignalUserId = await window.OneSignal.User.onesignalId;
              diagnosticInfo.externalUserId = await window.OneSignal.User.externalId;
            } catch (userError) {
              diagnosticInfo.userError = userError.message;
            }
            
            // Service Worker 상태 상세 확인
            if ('serviceWorker' in navigator) {
              try {
                const registrations = await navigator.serviceWorker.getRegistrations();
                diagnosticInfo.serviceWorkers = registrations.map(reg => ({
                  scope: reg.scope,
                  state: reg.active?.state,
                  scriptURL: reg.active?.scriptURL
                }));
              } catch (swError) {
                diagnosticInfo.serviceWorkerError = swError.message;
              }
            }
            
            console.log('구독 실패 진단 정보:', diagnosticInfo);
            
            // OS/브라우저별 특별한 처리 로직
            console.log('OS/브라우저별 추가 처리 시작');
            
            // WSL2 환경에서의 특별한 처리
            if (diagnosticInfo.isWSL) {
              console.log('WSL2 환경 감지, 추가 대기 및 권한 재설정');
              
              // WSL2에서는 Service Worker 초기화가 더 오래 걸릴 수 있음
              await new Promise(resolve => setTimeout(resolve, 5000));
              
              // 브라우저 네이티브 권한 재확인 및 강제 동기화
              try {
                if (Notification.permission === 'granted') {
                  console.log('WSL2 환경에서 브라우저 권한 재확인 성공, OneSignal 강제 동기화 시도');
                  
                  // 권한 요청을 통한 강제 동기화
                  await window.OneSignal.Notifications.requestPermission();
                  await new Promise(resolve => setTimeout(resolve, 2000));
                }
              } catch (wslError) {
                console.log('WSL2 환경 권한 동기화 실패:', wslError);
              }
            }
            
            // macOS Safari에서의 특별한 처리
            if (diagnosticInfo.isMacOS && diagnosticInfo.isSafari) {
              console.log('macOS Safari 환경 감지, Safari 특화 처리');
              
              // Safari는 푸시 알림 처리가 다를 수 있음
              await new Promise(resolve => setTimeout(resolve, 3000));
              
              try {
                // Safari에서는 명시적 권한 요청이 필요할 수 있음
                const safariPermission = await window.OneSignal.Notifications.requestPermission();
                console.log('Safari 권한 요청 결과:', safariPermission);
              } catch (safariError) {
                console.log('Safari 권한 요청 실패:', safariError);
              }
            }
            
            // 추가 구독 시도
            try {
              console.log('OS별 처리 후 추가 구독 시도 중...');
              
              // OneSignal User 설정 확인 및 재설정
              if (!diagnosticInfo.onesignalUserId) {
                console.log('OneSignal User ID가 없음, User 생성 대기');
                // User ID 생성을 위한 추가 대기
                await new Promise(resolve => setTimeout(resolve, 5000));
                
                // User ID 재확인
                try {
                  const newUserId = await window.OneSignal.User.onesignalId;
                  console.log('대기 후 User ID 확인:', newUserId);
                } catch (userCheckError) {
                  console.log('User ID 재확인 실패:', userCheckError);
                }
              }
              
              const secondOptInResult = await window.OneSignal.User.PushSubscription.optIn();
              console.log('두 번째 optIn 결과:', secondOptInResult);
              
              // 재확인 (환경에 따라 더 긴 대기)
              const waitTime = diagnosticInfo.isWSL ? 5000 : diagnosticInfo.isMacOS ? 4000 : 3000;
              console.log(`${waitTime}ms 대기 후 구독 상태 재확인`);
              await new Promise(resolve => setTimeout(resolve, waitTime));
              
              finalSubscribed = await window.OneSignal.User.PushSubscription.optedIn;
              console.log('추가 시도 후 구독 상태:', finalSubscribed);
              
              if (!finalSubscribed) {
                console.log('두 번째 시도도 실패, 환경별 문제 가능성:', {
                  os: diagnosticInfo.isMacOS ? 'macOS' : diagnosticInfo.isWindows ? 'Windows' : 'Linux/WSL',
                  browser: diagnosticInfo.isChrome ? 'Chrome' : diagnosticInfo.isSafari ? 'Safari' : 'Other'
                });
              }
              
            } catch (retryError) {
              console.error('추가 구독 시도 실패:', retryError);
            }
          }
        
        if (finalSubscribed) {
          const userId = await window.OneSignal.User.PushSubscription.id;
          console.log('구독 완료! 사용자 ID:', userId);
          
          Modal.success({
            title: '알림 설정 완료',
            content: 'OneSignal 푸시 알림이 성공적으로 설정되었습니다!',
          });

          // 상태 업데이트
          setIsPushEnabled(true);
          setOneSignalUserId(userId);

          // 서버에 등록 API 호출
          try {
            const accomId = sessionStorage.getItem("accomId");
            if (accomId) {
              await registerPushNotificationApi(userId, accomId);
              console.log('서버에 푸시 알림 등록 완료');
            }
          } catch (apiError) {
            console.error('서버 등록 API 호출 실패:', apiError);
            Modal.warning({
              title: '서버 등록 실패',
              content: '알림 설정은 완료되었지만 서버 등록에 실패했습니다.',
            });
          }

          // 테스트 알림 전송 (선택사항)
          try {
            await window.OneSignal.Notifications.display({
              title: '알림 테스트',
              body: 'OneSignal 푸시 알림이 정상적으로 설정되었습니다!',
            });
          } catch (e) {
            console.log('테스트 알림 표시 실패 (정상):', e);
          }
        } else {
          Modal.warning({
            title: '구독 실패',
            content: '알림 권한은 허용되었지만 구독 처리에 실패했습니다.',
          });
        }
        
        } catch (subscriptionError) {
          console.error('OneSignal 구독 중 오류:', subscriptionError);
          Modal.error({
            title: '구독 오류',
            content: `OneSignal 구독 중 오류가 발생했습니다: ${subscriptionError.message}`,
          });
        }
      } else {
        // 브라우저 네이티브 권한 상태 재확인
        const finalNativePermission = Notification.permission;
        console.log('최종 브라우저 권한 상태:', finalNativePermission);
        
        if (finalNativePermission === 'granted') {
          Modal.error({
            title: '알림 설정 실패',
            content: '브라우저 권한은 허용되었지만 OneSignal 구독에 실패했습니다. 페이지를 새로고침하고 다시 시도해주세요.',
          });
        } else {
          Modal.warning({
            title: '알림 권한 거부',
            content: `브라우저에서 알림 권한이 거부되었습니다. 
            현재 권한 상태: ${finalNativePermission}
            브라우저 설정에서 이 사이트의 알림을 허용해주세요.`,
          });
        }
      }

    } catch (error) {
      console.error('OneSignal 권한 요청 중 오류:', error);
      Modal.error({
        title: '오류 발생',
        content: `OneSignal 알림 설정 중 오류가 발생했습니다: ${error.message}`,
      });
    }
  };

  // 푸시 알림 해제 함수 (OneSignal 구독은 유지, 서버에서만 해제)
  const unsubscribeNotification = async () => {
    try {
      // 서버에서 해제 API 호출
      try {
        const accomId = sessionStorage.getItem("accomId");
        if (oneSignalUserId && accomId) {
          await unregisterPushNotificationApi(oneSignalUserId, accomId);
          console.log('서버에서 푸시 알림 해제 완료');
          
          // 상태 업데이트 (OneSignal 구독은 유지)
          setIsPushEnabled(false);
          // oneSignalUserId는 유지 (OneSignal 구독은 그대로 둠)
          
          Modal.success({
            title: '알림 해제 완료',
            content: '이 숙소의 푸시 알림이 해제되었습니다. (브라우저 알림 권한은 유지됩니다)',
          });
        } else {
          Modal.warning({
            title: '해제 실패',
            content: '사용자 ID 또는 숙소 정보를 찾을 수 없습니다.',
          });
        }
      } catch (apiError) {
        console.error('서버 해제 API 호출 실패:', apiError);
        Modal.error({
          title: '서버 해제 실패',
          content: '푸시 알림 해제에 실패했습니다. 다시 시도해주세요.',
        });
      }
    } catch (error) {
      console.error('푸시 알림 해제 중 오류:', error);
      Modal.error({
        title: '오류 발생',
        content: `푸시 알림 해제 중 오류가 발생했습니다: ${error.message}`,
      });
    }
  };

  // 푸시 알림 토글 핸들러
  const handlePushToggle = async (checked) => {
    if (checked) {
      // 알림 활성화
      await requestNotificationPermission();
    } else {
      // 알림 해제
      await unsubscribeNotification();
    }
  };

  // 알림창 card
  const [cards, setCards] = useState([
    // {
    //   id: 1,
    //   title: "알림 1",
    //   content: `이것은 알림 메시지 1입니다.`,
    // },
    // {
    //   id: 2,
    //   title: "알림 2",
    //   content: `이것은 알림 메시지 2입니다.`,
    // },
    // { id: 3, title: "알림 3", content: "이것은 알림 메시지 3입니다." },
  ]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await notifySearchApi();
        const resArray = Object.entries(res.notifies);
        const notifyArray = resArray.map(([key, value]) => {
          return {
            id: key,
            title: value.title,
            content: value.message,
          };
        });
        setCards(notifyArray);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);
  const handleClose = (id) => {
    setCards(cards.filter((card) => card.id !== id)); // 해당 카드 삭제
  };

  // 룸정보
  const [roomAllList, setRoomAllList] = useState([]);

  // 상태별 카운팅
  const stateCount = roomAllList.reduce((acc, rooms) => {
    const state = rooms.value.state_summary;
    acc[state] = (acc[state] || 0) + 1;
    return acc;
  }, {});
  // console.log(Object.keys(stateCount));

  // 객실상태 제어 checkbox
  const CheckboxGroup = Checkbox.Group;
  /*
  const plainOptions = Object.keys(stateCount).map((state) => ({
    label:
      // 상태와 개수
      state === "EMPTY"
        ? `퇴실 (${stateCount[state]})`
        : state === "USING"
        ? `입실 (${stateCount[state]})`
        : state === "OUTING"
        ? `외출 (${stateCount[state]})`
        : state === "CLEANING"
        ? `청소중 (${stateCount[state]?  0})`
        : state === "CLEAN_ORDER"
        ? `청소요청 (${stateCount[state]})`
        : state === "INSPECTING"
        ? `점검중 (${stateCount[state]})`
        : state === "INSPECT_ORDER"
        ? `점검요청 (${stateCount[state]})`
        : `퇴실 (${stateCount[state]})`,
    value: state, // 상태 자체를 value로 설정
  }));*/
  const plainOptions = [
    {value: "USING", label: "입실"},
    {value: "EMPTY", label: "퇴실"},
    {value: "OUTING", label: "외출"},
    {value: "CLEAN_ORDER", label: "청소요청"},
    {value: "CLEANING", label: "청소중"},
    {value: "INSPECT_ORDER", label: "점검요청"},
    {value: "INSPECTING", label: "점검중"},
  ];
  
  for (let i = 0; i < plainOptions.length; i++) {
    plainOptions[i].label = plainOptions[i].label + " (" + ( stateCount[plainOptions[i].value] !== undefined ? stateCount[plainOptions[i].value] : 0 ) + ")";
  }

  const defaultCheckedList = Object.keys(stateCount).map((state) => [
    {
      label: state === "EMPTY",
    },
  ]);

  const [checkedListRoomControl, setCheckedListRoomControl] =
    useState(defaultCheckedList);
  const checkAll = plainOptions.length === checkedListRoomControl.length;
  // console.log(checkAll);
  const indeterminate =
    checkedListRoomControl.length > 0 &&
    checkedListRoomControl.length < plainOptions.length;
  // console.log(indeterminate);
  // console.log("선택됨: ", checkedListRoomControl);
  const onChangeRoomControl = (list) => {
    setCheckedListRoomControl(list);
    console.log("선택됨: ", checkedListRoomControl);
  };
  const onCheckAllChangeRoomControl = (e) => {
    const selectedOptionArr = [];
    plainOptions.map((opt) => {
      selectedOptionArr.push(opt.value);
    });
    setCheckedListRoomControl(e.target.checked ? selectedOptionArr : []);
  };

  // 모바일 메뉴
  const [openMoMenu, setOpenMoMenu] = useState(false);
  const showDrawerMoMenu = () => {
    setOpenMoMenu(true);
  };
  const onCloseMoMenu = () => {
    setOpenMoMenu(false);
  };

  return (
    <>
      {pathname === "/404" ? (
        <Z_NotFoundSample />
      ) : (
        <div className="container">
          <div className="header">
            <div className={"clock-area"}>
              <MainClock accomOnlyList={accomOnlyList} />
            </div>
            <div className="inner">
              <div className="top">
                {/* <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: "auto",
                  }}
                >
                  <Checkbox
                    indeterminate={indeterminate}
                    onChange={onCheckAllChangeRoomControl}
                    checked={checkAll}
                  >
                    전체 ({plainOptions.length})
                  </Checkbox>
                  <div className="line-col"></div>
                </div> */}
                {/* 업소명 - 화면이 좁아지면 숨김 */}
                <div 
                  className="accom-name-responsive" 
                  style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '6px',
                    padding: '4px 11px',
                    borderRadius: '6px',
                    border: '1px solid #d9d9d9',
                    backgroundColor: '#f0f0f0',
                    color: '#666',
                    fontSize: '14px',
                    fontWeight: '500',
                    marginRight: '8px',
                    flexShrink: 0
                  }}
                >
                  <HomeOutlined />
                  {accomOnlyList[0]?.name}
                </div>
                
                {/* 우측 버튼 그룹 - 항상 오른쪽에 고정 */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: 'auto' }}>
                  <Tooltip title={isPushEnabled ? "알림 끄기" : "알림 받기"}>
                    <Button
                      type="primary"
                      onClick={handlePushToggle}
                      style={{ 
                        backgroundColor: isPushEnabled ? '#52c41a' : '#d9d9d9',
                        borderColor: isPushEnabled ? '#52c41a' : '#d9d9d9',
                        color: isPushEnabled ? '#fff' : '#666'
                      }}
                    >
                      {isPushEnabled ? <BellFilled /> : <BellOutlined />}
                    </Button>
                  </Tooltip>
                  <Tooltip title="매출보기">
                    <Button type="primary" onClick={showDrawer}>
                      <BarChartOutlined />
                    </Button>
                  </Tooltip>
                  <Tooltip title={"로그아웃"}>
                    <Button
                      type="primary"
                      onClick={handleLogout}
                      title="로그아웃"
                    >
                      <LogoutOutlined />
                    </Button>
                  </Tooltip>
                  <Button
                    type="primary"
                    title="모바일 메뉴"
                    className="menu-mobile hide"
                    onClick={showDrawerMoMenu}
                  >
                    <MenuOutlined />
                  </Button>
                </div>
                <Drawer
                  title={<div className="font-20-900">모바일 메뉴</div>}
                  onClose={onCloseMoMenu}
                  open={openMoMenu}
                  className="menu-mobile-open"
                  width={"210px"}
                >
                  <MainMenu
                    currentMenuKey={currentMenuKey}
                    setCurrentMenuKey={setCurrentMenuKey}
                  />
                </Drawer>
              </div>
              {currentMenuKey === "1" && pathname === "/" ? (
                <div className="bottom">
                  <div
                    className="flex-row"
                    style={{ flexWrap: "nowrap", whiteSpace: "nowrap" }}
                  >
                    <Checkbox
                      indeterminate={indeterminate}
                      onChange={onCheckAllChangeRoomControl}
                      checked={checkAll}
                    >
                      전체 ({roomAllList.length})
                    </Checkbox>
                    <div className="line-col"></div>
                  </div>
                  <CheckboxGroup
                    options={plainOptions}
                    value={checkedListRoomControl}
                    onChange={onChangeRoomControl}
                  />
                </div>
              ) : null}
            </div>
          </div>

          <div
            className="flex-row"
            style={{
              width: "100%",
              height: "100%",
              // border: "1px solid red",
              gap: "24px",
              alignItems: "stretch",
            }}
          >
            <MainMenu
              toggleCollapsed={toggleCollapsed}
              collapsed={collapsed}
              setCollapsed={setCollapsed}
              currentMenuKey={currentMenuKey}
              setCurrentMenuKey={setCurrentMenuKey}
            />
            <div className={!collapsed ? "body-wrap" : "body-wrap fold"}>
              <div className="body">
                <Outlet /> {/* 하위 라우트가 렌더링될 위치 */}
                
                { pathname === "/" ? (
                  <Rooms
                  roomAllList={roomAllList}
                  setRoomAllList={setRoomAllList}
                  checkedListRoomControl={checkedListRoomControl}
                  />
                ): null}
              </div>
              <footer>
                { pathname === "/" ? 
                <div className="commu-status">
                  {/* <Tooltip
                    title={
                      <div className="text-c">
                        업소의 모든 상황을 안정적으로 관리해주는 최신 기술이
                        적용된 클라우드 서버 입니다.
                        <br />
                        파란색: 통신정상 <br />
                        빨간색: 통신단절
                      </div>
                    }
                  >
                    <Tag color="blue">API</Tag>
                  </Tooltip>
                  <Tooltip
                    title={
                      <div className="text-c">
                        업소의 모든 장치간의 이벤트에 대한 실시간 동기화를
                        가능하게 해주는 서버입니다.
                        <br />
                        파란색: 통신정상 <br />
                        빨간색: 통신단절
                      </div>
                    }
                  >
                    <Tag color="blue">Event</Tag>
                  </Tooltip>
                  <Tooltip
                    title={
                      <div className="text-c">
                        적색 표기시 키오스크에 문제가 발생한 경우입니다.
                        <br />
                        파란색: 정상 <br />
                        빨간색: 통신단절
                      </div>
                    }
                  >
                    <Tag color="red">KIOSK</Tag>
                  </Tooltip>
                  <Tooltip
                    title={
                      <div className="text-c">
                        데몬은 객실의 상태 정보를 동기화 시켜주는 역할을 하며,
                        적색 표기시 키 여부 등, 객실 상태가 동기화 되지 않을 수
                        있습니다.
                        <br />
                        파란색: 정상 <br />
                        빨간색: 통신단절
                      </div>
                    }
                  >
                    <Tag color="red">DEMON</Tag>
                  </Tooltip>
                  <Tooltip
                    title={
                      <div className="text-c">
                        프론트에 설치된 객실관리 프로그램을 의미합니다.
                        <br />
                        파란색: 정상 <br />
                        빨간색: 통신단절
                      </div>
                    }
                  >
                    <Tag color="red">FRONT</Tag>
                  </Tooltip> */}
                </div>
                : null}
                <a href="tel:1600-5356" className="tel">
                  CS ☎ 1600-5356
                </a>
                {/* <p className="font-14-500">v2.21.4</p> */}
                <a href="#">
                  <Badge
                    count={cards.length}
                    className="mr-16"
                    onClick={showDrawerAlarm}
                    title={"알림창 열기"}
                    showZero={false}
                  >
                    <Avatar shape="square" icon={<BellOutlined />} />
                  </Badge>
                </a>
              </footer>
            </div>
          </div>

          <Drawer
            title={<h2 className="ml-16">매출보기</h2>}
            onClose={onClose}
            open={open}
            placement={"left"}
            maskClosable={true}
            size={"large"}
          >
            <Tabs
              onChange={onChangeSalesTableTab}
              // type="card"
              items={[
                {
                  key: "1",
                  label: "금일",
                  // children: <SalesTable1 />,
                  children: <SalesTable2 />,
                },
                // { key: "2", label: "전일", children: "전일" },
                // { key: "3", label: "금월", children: "금월" },
                // { key: "4", label: "전월", children: "전월" },
              ]}
            />
          </Drawer>

          <Drawer
            title={<h2 className="ml-16">알람창</h2>}
            onClose={onCloseAlarm}
            open={openAlarm}
            placement={"right"}
            maskClosable={true}
            size={"default"}
            className="alarm"
          >
            <div className="flex-col gap-16">
              {cards.map((card) => (
                <NotificationCard
                  key={card.id}
                  id={card.id}
                  title={card.title}
                  content={card.content}
                  onClose={handleClose} // 카드 닫기 함수 전달
                />
              ))}
            </div>
          </Drawer>
        </div>
      )}
    </>
  );
};
